import { CaretDownFilled, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Dropdown,
  Menu,
  Checkbox,
} from 'antd'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../compnents/form/DateSelect'
import { ThemeContext } from '../../theme/ThemeContext'
import styles from './chainSalesStatistics.module.css'
import { FilterColumn } from '../../compnents/filterForm/filterForm'
import { getChainListAsync } from '../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'
import { stringTrim } from '../../utils/StringUtils'
import { selectInsuranceArray } from '../../app/applicationSlice'

export const Query = (props: {
  exportLoading?: any
  loading?: any
  filterColumn?: any
  filterSelectList?: any
  submitPageList?: (selectedColumns: string[]) => void
  onValueChange: (params: any) => void
  export?: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const Option = Select.Option

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [organizationData, setOrganizationData] = useState<any>([])

  const [isAccurate, setIsAccurate] = useState<boolean>(false)

  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationData(res)
      })
  }, [])

  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        props.onValueChange({
          ...values,
          isAccurate: isAccurate,
          tenantIds: values?.tenantIds?.length ? values?.tenantIds.join(',') : '',
        })
      }}
    >
      <Row style={{ marginTop: 10, marginBottom: 10 }} justify='space-between'>
        <Space wrap>
          <Form.Item
            name='tenantSupplierName'
            noStyle
            getValueFromEvent={stringTrim}
          >
            <Input
              autoComplete='off'
              placeholder='请输入生产厂家'
              style={{ width: 160 }}
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
              allowClear
            />
          </Form.Item>
          <Form.Item
            name='params'
            noStyle
            getValueFromEvent={stringTrim}
          >
            <Input
              autoComplete='off'
              placeholder='请输入药品信息'
              style={{ width: 160 }}
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
              allowClear
            />
          </Form.Item>
          <Form.Item name='tenantIds' noStyle>
            <Select
              placeholder='机构名称'
              allowClear
              mode='multiple'
              dropdownClassName={styles.selectDropdown}
              style={{ minWidth: 150, maxWidth: 410 }}
              onChange={form.submit}
            >
              {organizationData?.map((v: any) => {
                return (
                  <Option value={v?.id?.toString()} key={v?.id}>
                    {v?.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {insuranceArray && insuranceArray.length !== 0 && (
            <Form.Item name='insuranceCode' noStyle>
              <Select
                placeholder='险种类型'
                style={{ width: '7rem' }}
                onChange={(key) => {
                  form.submit()
                }}
              >
                <Select.Option value={''}>全部</Select.Option>
                <Select.Option value={'ZIFEI'}>自费</Select.Option>
                {insuranceArray.map((v) => (
                  <Select.Option value={v.insuranceCode} key={v.id}>
                    {v.insuranceName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='payStatus' noStyle>
            <Select
              placeholder='结算状态'
              style={{ width: '7rem' }}
              allowClear
              onChange={(key) => {
                form.submit()
              }}
            >
              <Select.Option value={' '}>全部</Select.Option>
              <Select.Option value={'3'}>已收费</Select.Option>
              <Select.Option value={'5'}>已退费</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='isMerge' noStyle>
            <Select
              style={{ width: '7rem' }}
              defaultValue={0}
              allowClear={false}
              placeholder='是否合并'
              onChange={() => {
                form.submit()
              }}
            >
              <Option value={0}>合并-否</Option>
              <Option value={1}>合并-是</Option>
            </Select>
          </Form.Item>
          <DateSelect
            allowClear={false}
            style={{ width: '7rem' }}
            labelPrefix=''
            namePrefix='time'
            options={TJFXTime}
            placeholder='结算时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e !== 6) {
                form.submit()
              }
            }}
          />
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
          <Checkbox.Group>
            <Checkbox value={'0'} onChange={(v => {
              setIsAccurate(v.target.checked);
              form.submit()
            })}>是否精确查询</Checkbox>
          </Checkbox.Group>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export && props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
